document.addEventListener('DOMContentLoaded', function () {
	// Get the radio buttons
	const employmentTypeRadios = document.querySelectorAll('input[name="employment_type"]');
	const staffABN = document.getElementById('staffABN');
	const staffTFN = document.getElementById('staffTFN');
	const isManager = document.getElementById('isManager');
	const managerPasswordEl = document.getElementById('managerPassword');

	// Return if the radio buttons are not found
	if (!employmentTypeRadios) {
		return;
	}

	// Function to toggle visibility
	function toggleVisibility() {
		const selectedValueEl = document.querySelector('input[name="employment_type"]:checked');

		if (!selectedValueEl) {
			return;
		}

		const selectedValue = selectedValueEl.value;
		const publicLiabilityCert = document.getElementById('publicLiabilityCertificate');
		const certOfCurrency = document.getElementById('certificateOfCurrency');

		if (selectedValue === 'A') {
			// Show ABN field, hide TFN
			staffABN.classList.remove('d-none');
			staffTFN.classList.add('d-none');

			if (publicLiabilityCert) {
				publicLiabilityCert.classList.remove('d-none');
			}

			if (certOfCurrency) {
				certOfCurrency.classList.remove('d-none');
			}

		} else if (selectedValue === 'E') {
			// Show TFN field, hide ABN
			staffABN.classList.add('d-none');
			staffTFN.classList.remove('d-none');

			if (publicLiabilityCert) {
				publicLiabilityCert.classList.add('d-none');
			}

			if (certOfCurrency) {
				certOfCurrency.classList.add('d-none');
			}
		}
	}

	// Add event listeners to all radio buttons
	employmentTypeRadios.forEach(function (radio) {
		radio.addEventListener('change', toggleVisibility);
	});

	if (isManager) {

		const showManagerPassword = () => {
			if (isManager.querySelector('input').checked) {
				managerPasswordEl.classList.remove('d-none');
			} else {
				managerPasswordEl.classList.add('d-none');
			}
		}

		// Add event listener for the manager checkbox
		isManager.querySelector('input').addEventListener('change', function () {
			showManagerPassword()
		});

		managerPasswordEl.querySelector('button').addEventListener('click', function () {
			if (managerPasswordEl.querySelector('input').type === 'password') {
				managerPasswordEl.querySelector('input').type = 'text';  // Show the password
				managerPasswordEl.querySelector('input').textContent = 'Hide';  // Change button text
			} else {
				managerPasswordEl.querySelector('input').type = 'password';  // Hide the password
				managerPasswordEl.querySelector('input').textContent = 'Show';  // Change button text
			}
		});

		showManagerPassword()

	}

	// Call toggleVisibility on page load in case a radio button is already selected
	toggleVisibility();
});